// extracted by mini-css-extract-plugin
export default {"root":"EditListingDeliveryPanel_root__5gCAD","form":"EditListingDeliveryPanel_form__xyCO8","priceCurrencyInvalid":"EditListingDeliveryPanel_priceCurrencyInvalid__9tgP0"};